import styled from '@emotion/styled';

import BackgroundImage from '../assets/images/verantos-background.png';

const AppBackground = styled.div`
  background-image: url(${BackgroundImage});
  background-size: cover;
  background-position: center;
  background-repeat: no-repeat;
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  display: flex;
  align-items: center;
  justify-content: center;
`;

const Content = styled.div`
  flex: 1;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 2rem;
  text-align: center;
  background: rgba(0, 52, 89, 0.95);
  height: 100%;
`;

const Title = styled.h1`
  color: #ff3b30;
  font-size: 2.5rem;
  margin-bottom: 1.5rem;
  font-weight: 500;
`;

const Message = styled.p`
  color: #ffffff;
  font-size: 1.2rem;
  margin-bottom: 2rem;
  max-width: 600px;
`;

const Button = styled.button`
  padding: 0.75rem 2rem;
  background-color: #2196f3;
  color: white;
  border: none;
  border-radius: 4px;
  cursor: pointer;
  font-size: 1rem;
  font-weight: 500;
  transition: background-color 0.2s;

  &:hover {
    background-color: #1976d2;
  }
`;

export const ErrorFallback = () => (
  <AppBackground>
    <Content>
      <Title>Oops! Something went wrong</Title>
      <Message>We've been notified and are working to fix the issue.</Message>
      <Button onClick={() => window.location.reload()}>Reload Page</Button>
    </Content>
  </AppBackground>
);
